import ReferraDepartment from "./ReferraDepartment";
export default ReferraDepartment;
